<template>
    <div class="login-wrap">
        <language></language>
        <div class="ms-login">
            <div class="ms-title">{{$t('login.title')}}</div>
            <el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">
                <el-form-item prop="username">
                    <el-input v-model="param.username" placeholder="Username">
                        <el-button slot="prepend" icon="el-icon-user"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input
                        type="password"
                        placeholder="password"
                        v-model="param.password"
                        @keyup.enter.native="submitForm()"
                    >
                        <el-button slot="prepend" icon="el-icon-lock"></el-button>
                    </el-input>
                </el-form-item>
                <div class="login-btn">
                    <el-button type="primary" @click="submitForm()">{{ $t("login.logIn") }}</el-button>
                    <!--<el-button type="success" @click="register()">{{$t("login.register")}}</el-button>-->
                </div>
                <!--<p class="login-tips">Tips : 用户名和密码随便填。</p>-->
            </el-form>
        </div>
    </div>
</template>

<script>
import language from "@/components/Language";
import {mapState, mapMutations} from 'vuex';
export default {
    name: "login",
    components:{
        language
    },
    data: function () {
        return {
            param: {
                username: '',
                password: '',
                // username: 'piliw',
                // password: '123456',
            },
            rules: {
                username: [{required: true, message: '请输入登陆账号', trigger: 'blur'}],
                password: [{required: true, message: '请输入登陆密码', trigger: 'blur'}],
            },
        };
    },
    computed:{
        ...mapState(['access_token','refresh_token']),
    },
    methods: {
        ...mapMutations(['setLogin', 'setUserMenus', 'setUserRoles']),
        submitForm() {
            this.$refs.login.validate(valid => {
                if (valid) {
                    this.http.fetchPost(this.api.login, this.param).then((res) => {
                        var data = res.data;
                        console.log(data.code)
                        if (data.code === 200) {
                          // 保存token
                          this.setLogin(data.data);
                          
                          // 保存用户角色（登录接口已返回）
                          if (data.data.roles) {
                              this.setUserRoles(data.data.roles);
                          }
                          
                          // 获取用户菜单
                          this.http.fetchGet(this.api.user_menus).then((menuRes) => {
                                var menuData = menuRes.data;
                                if (menuData.code === 200) {
                                    // 保存菜单数据
                                    this.setUserMenus(menuData.data.menus || []);
                                    // 保存角色数据（如果菜单接口也返回了）
                                    if (menuData.data.roles) {
                                        this.setUserRoles(menuData.data.roles);
                                    }
                                this.$message.success('登陆成功');
                                this.$router.push('/');
                                } else {
                                    this.$message.error('获取菜单失败');
                                }
                              }
                          ).catch(err => {
                            console.log(err)
                            this.$message.error('获取菜单失败');
                          })
                        }else{
                            this.$message.error(data.msg);
                        }
                        // 请求成功处理
                    }).catch(err => {
                        console.log(err)
                    })

                } else {
                    // this.$message.error('请输入账号和密码');
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        register() {
            this.$router.push('/register')
        }
    },
}
</script>

<style scoped lang="stylus">

.login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    /*background-image: url(../../assets/img/login-bg.jpg);*/
    background-size: 100%;
    background-color: #eeeeee;
}

.ms-title {
    width: 100%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #393d49;
    border-bottom: 1px solid #ddd;
}

.ms-login {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 350px;
    margin: -190px 0 0 -175px;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.3);
    overflow: hidden;
}

.ms-content {
    padding: 30px 30px;
}

.login-btn {
    text-align: center;
    display flex
    justify-content space-between

}

.login-btn button {
    /*display:flex*/
    /*float left*/
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
}

.login-tips {
    font-size: 12px;
    line-height: 30px;
    color: #393d49;
}

</style>
